import { cloneDeep, get } from "lodash"
import { ApplicationStep3, PrivateSolicitor } from "../ApplicationStep3.class";
import { StructureStatusEnum } from "../../enum/structure-status.enum";
import data from "../../../../src/utils/shared/dummy.json";
import moment from "moment";

export const StageD1NewJSON = data.StageD1NewJSON;

export const StageD1NewJsonV2 = data.StageD1NewJsonV2;
export const StageD1NewJsonV3 = data.StageD1NewJsonV3;

export const StageD2NewJson = data.StageD2NewJson;
export const StageD2NewJsonV2= data.StageD2NewJsonV2;


export const StageD2NewJsonV3=data.StageD2NewJsonV3;

export const StageD4NewJsonV2 = data.StageD4NewJsonV2;



export class StageDSolicitorApplication extends ApplicationStep3{
  uuid : string;
  group_uuid : string;
  
  constructor(initial?: StageDSolicitorApplication){
    super(initial);
    this.uuid = get(initial, 'uuid', "");
    this.group_uuid = get(initial, 'group_uuid', "");
    
  }
  
}

export class StageDSolicitorApplicationForm{
  solicitors: StageDSolicitorApplication[]
  constructor(initial?: StageDSolicitorApplication){
    this.solicitors = get(initial, 'solicitors', []);
  }
}

export type StageDMessageType = "GENERIC" | "SOLICITOR";
export type OwnerType = "CURRENT_OWNER" | "PROPOSED_OWNER" | "OUTGOING_OWNER";
export type SolicitorRequestType = "MORTGAGE" | "CONVEYANCING" | "BOTH"

export class StageDReviewApplication{
  private static readonly IPA_FOLDER_NAME = "In-Principle Approval";
  private static readonly CURRENT_FP_FOLDER_NAME = "Financial Plan for Current Owners";
  private static readonly PROPOSED_FP_FOLDER_NAME = "Financial Plan for Proposed Owners";
  private static readonly LEGAL_DOCS_FOLDER_NAME = "Legal Documents";
  
  application_uuid: string;
  message_info: StageDMessageInfo[];
  folders: StageDocumentsInfo[];
  message_type?: StageDMessageType;
  solicitor_group_uuid?: string[];
  solicitor_parent_uuid?: string[];
  solicitor_message_info?: StageDMessageInfo[];
  hasFinancialPlan?: boolean;
  hasLegalDocsReady?: boolean;

  constructor(initial?: StageDReviewApplication){
    this.application_uuid = get(initial, 'application_uuid', "");
    this.message_info = get(initial, 'message_info', []);
    this.folders = get(initial, 'folders', []);
    this.message_type = get(initial, 'message_type', "GENERIC");
    this.solicitor_group_uuid = get(initial, 'solicitor_group_uuid', []);
    this.solicitor_parent_uuid = get(initial, 'solicitor_parent_uuid', []);
    this.solicitor_message_info = get(initial, 'solicitor_message_info', []);

  }

  stageD1ProcessFolders?() {
    this.message_type = this.message_info.some((e) => e.type === "SOLICITOR") ? "SOLICITOR" : "GENERIC";
    this.solicitor_message_info = this.message_info.filter((e) => e.type === "SOLICITOR");
    this.message_info = this.message_info.filter((e) => e.type === "GENERIC");

    //NOTE: if tester stay in D1 and refresh the page after officer approved, it will show the IPA in D1. So did this to remove these specific files/folders from folders variable.
    this.folders = this.folders.filter(
      (e) =>
        e.name !== StageDReviewApplication.IPA_FOLDER_NAME &&
        e.name !== StageDReviewApplication.CURRENT_FP_FOLDER_NAME &&
        e.name !== StageDReviewApplication.PROPOSED_FP_FOLDER_NAME
    );
    //Did this so when refresh in D1, IPA
  }

  stageD2ProcessFolders?() {
    this.message_type = this.message_info.some((e) => e.type === "SOLICITOR") ? "SOLICITOR" : "GENERIC";
    this.solicitor_message_info = this.message_info.filter((e) => e.type === "SOLICITOR");
    this.message_info = this.message_info.filter((e) => e.type === "GENERIC");

    this.hasFinancialPlan = this.folders.some(
      (e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME || e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME
    );
  }

  stageD4ProcessFolders?(structure_status: StructureStatusEnum) {
    this.message_type = this.message_info.some((e) => e.type === "SOLICITOR") ? "SOLICITOR" : "GENERIC";
    this.solicitor_message_info = this.message_info.filter((e) => e.type === "SOLICITOR");
    this.message_info = this.message_info.filter((e) => e.type === "GENERIC");

    this.hasFinancialPlan = this.folders.some(
      (e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME || e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME
    );
    this.hasLegalDocsReady = this.folders.some((e) => e.name === StageDReviewApplication.LEGAL_DOCS_FOLDER_NAME);

    const requestFolders = this.folders.filter((item) => item.is_request_document);

    if (structure_status === StructureStatusEnum.incoming) {
      //Only show proposed
      console.log("Only show proposed");
      this.folders = this.folders.filter((e) => e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME).concat(requestFolders);
    } else if (structure_status === StructureStatusEnum.outgoing) {
      //Only show current
      console.log("Only show current");
      this.folders = this.folders.filter((e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME).concat(requestFolders);
    } else if (structure_status === StructureStatusEnum.retaining) {
      //Show current and proposed
      console.log("Only show both");
      this.folders = this.folders
        .filter((e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME || e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME)
        .concat(requestFolders);
    }

    const formatted_folders = cloneDeep(this.folders);

    const allCommentsFromFormattedFolders = formatted_folders.map((e) => {
      let latestComment = e.comments;
      if (latestComment && latestComment.length > 0) {
        latestComment = latestComment.slice(-1);
      }
      return new StageDocumentsInfo({ ...e, comments: [...latestComment] });
    });

    this.folders = allCommentsFromFormattedFolders;

    console.log("post temp_folders", this.folders);
    console.log("hasLegalDocsReady", this.hasLegalDocsReady);
  }

  stageDDefaultJSON?(){
    this.folders = [];
    this.message_info = [];
  }

  stageEProcessFolders?(){
    const temp_folders = [...this.folders];
    const refer_folder_name = "Legal Documents";

    this.folders = temp_folders.filter(e=> e.name === refer_folder_name);
  }
  
  json?(){
    return this;
  }
}



export class StageDMessageInfo{
  uuid:string
  due_date: string
  parent_uuid?: string
  group_uuid: string
  subject: string
  message: string
  received_date: string
  type: StageDMessageType | any
  status?: string
  reply?: string
  replied_by?: string
  replied_at?: string
  is_saved?: boolean
  owner_type?: OwnerType
  solicitor_request_type?: SolicitorRequestType
  
  constructor(initial?: StageDMessageInfo){
    this.uuid = get(initial,'uuid','');
    this.parent_uuid = get(initial,'parent_uuid','');
    this.group_uuid = get(initial,'group_uuid','');
    this.due_date = get(initial,'due_date','');
    this.subject = get(initial,'subject','');
    this.message = get(initial,'message','');
    this.received_date = get(initial,'received_date','');
    this.status = get(initial,'status','');
    this.type = get(initial,'type','GENERIC');
    this.owner_type = get(initial, 'owner_type', undefined);
    this.solicitor_request_type = get(initial, 'solicitor_request_type', undefined);
  
    this.reply = get(initial,'reply','');
    this.replied_by = get(initial,'replied_by','')
    this.replied_at = get(initial,'replied_at','')
    this.is_saved = get(initial,'is_saved',false);
  }
}
export class StageDocumentsInfo{
  
  uuid: string;
  name: string;
  due_date: string;
  received_date: string;
  is_request_document: boolean;
  comments: StageDCommentsInfo[];

  constructor(initial?: StageDocumentsInfo){
    this.uuid = get(initial,'uuid','');
    this.name = get(initial,'name','');
    this.due_date = get(initial,'due_date','');
    this.received_date = get(initial,'received_date','');
    this.is_request_document = get(initial,'is_request_document',false);
    this.comments = get(initial,'comments',[]);
  }
}

export class StageDCommentsInfo{
  uuid: string;
  text: string;
  documents: StageDDocumentsInfo[];

  constructor(initial?: StageDocumentsInfo){
    this.uuid = get(initial,'uuid','');
    this.text = get(initial,'text','');
    this.documents = get(initial,'documents',[]);
  }
}

export class StageDDocumentsInfo{
  uuid: string;
  key: string;
  name: string;
  submitted_date?: string;
  size: number;

  constructor(initial?: StageDDocumentsInfo){
    this.uuid = get(initial,'uuid','');
    this.key = get(initial,'key','');
    this.name = get(initial,'name','');
    this.submitted_date = get(initial, 'submitted_date', "");
    this.size = get(initial,'size',0);
  }
}


export class StageDSolicitorUpdate{
  application_uuid: string | null;
  parent_uuid: string;
  group_uuid: string;
  infos : StageDSolicitor[]

  constructor(initial?:StageDSolicitorUpdate){
    this.application_uuid = get(initial,'application_uuid', "");
    this.parent_uuid      = get(initial,'parent_uuid', "");
    this.group_uuid       = get(initial,'group_uuid', "");
    this.infos            = get(initial,'infos', []);
  }

  setApplicationUuid(application_uuid:string | null){
    this.application_uuid = application_uuid;
  }
  setParentUuid(parent_uuid:string){
    this.parent_uuid = parent_uuid;
  }
  setGroupUUid(group_uuid:string){
    this.group_uuid = group_uuid;
  }
  setProposedSolicitor(initial:StageDSolicitorApplication, solicitorRequestType: SolicitorRequestType = "BOTH"){
    const private_solicitor:PrivateSolicitor = initial.proposed.private_solicitor;
    const conveyancing_solicitor:PrivateSolicitor = initial.proposed.conveyancing_private_solicitor;

    switch (solicitorRequestType) {
      case "MORTGAGE": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        this.infos = [mortgateSolicitor];
        break;
      }

      case "CONVEYANCING": {
        const conveyancingSolicitor = new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
        this.infos = [conveyancingSolicitor];
        break;
      }

      case "BOTH": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        
        const conveyancingSolicitor = initial.proposed.private_solicitor.represented_same_solicitor ? new StageDSolicitor({...mortgateSolicitor, type:"CONVEYANCING"}) : 
        new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
    
        this.infos = [mortgateSolicitor, conveyancingSolicitor];
      }
    }
  }

  setCurrentSolicitor(initial:StageDSolicitorApplication, solicitorRequestType: SolicitorRequestType = "BOTH"){
    const private_solicitor:PrivateSolicitor = initial.current.private_solicitor;
    const conveyancing_solicitor:PrivateSolicitor = initial.current.conveyancing_private_solicitor;
    
    switch (solicitorRequestType) {
      case "MORTGAGE": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        this.infos = [mortgateSolicitor];
        break;
      }
      case "CONVEYANCING": {
        const conveyancingSolicitor = new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
        this.infos = [conveyancingSolicitor];
        break;
      }
      case "BOTH": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });

        const conveyancingSolicitor = initial.proposed.private_solicitor.represented_same_solicitor ? new StageDSolicitor({...mortgateSolicitor, type:"CONVEYANCING"}) : 
        new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });

        this.infos = [mortgateSolicitor, conveyancingSolicitor];
      }
    }
  }

  setOutgoingSolicitor(initial:StageDSolicitorApplication, solicitorRequestType: SolicitorRequestType = "BOTH"){
    const private_solicitor:PrivateSolicitor = initial.outgoing.private_solicitor;
    const conveyancing_solicitor:PrivateSolicitor = initial.outgoing.conveyancing_private_solicitor;
    
    switch (solicitorRequestType) {
      case "MORTGAGE": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        this.infos = [mortgateSolicitor];
        break;
      }
      case "CONVEYANCING": {
        const conveyancingSolicitor = new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
        this.infos = [conveyancingSolicitor];
        break;
      }
      case "BOTH": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });

        const conveyancingSolicitor = initial.proposed.private_solicitor.represented_same_solicitor ? new StageDSolicitor({...mortgateSolicitor, type:"CONVEYANCING"}) : 
        new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });

        this.infos = [mortgateSolicitor, conveyancingSolicitor];
      }
    }
  }

  json(){
    return this;
  }
}


export class StageDSolicitorParent{
  solicitor: StageDSolicitorUpdate[];
  constructor(initial?:StageDSolicitorParent){
    this.solicitor = get(initial,'solicitor',[]);
  }


}

class StageDSolicitor{
  type: "MORTGAGE" | "CONVEYANCING" | null
  name: string
  email: string
  uen: string

  constructor(initial:StageDSolicitor){
    this.type = get(initial,'type', null);
    this.name = get(initial,'name', "");
    this.email = get(initial,'email', "");
    this.uen = get(initial,'uen', "");

  }
}
